export { default } from './AmazonWidget';



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/Amazon/AmazonWidget/index.js